import React, { useState, useEffect, useRef } from 'react'
import {
    EyeIcon,
    ArrowLeftIcon,
    PencilIcon,
    ArrowPathIcon,
    ChevronDownIcon,
    CheckCircleIcon,
    WifiIcon,
    InformationCircleIcon,
    FunnelIcon,
    ChatBubbleBottomCenterIcon,
    PhoneIcon,
    PrinterIcon,
    EnvelopeIcon,
    UserIcon,
    PlusCircleIcon, // Add this import
    XMarkIcon,
    CheckIcon,
    DocumentIcon,
    ArrowDownTrayIcon,
    ClockIcon,
    CurrencyDollarIcon,
    IdentificationIcon,
    SparklesIcon,
    TicketIcon,
    PercentBadgeIcon,
    BriefcaseIcon,
    DocumentTextIcon,
    StarIcon,
    ShieldCheckIcon,
} from '@heroicons/react/20/solid'
// Fix: Update Headless UI imports
import { Disclosure, Menu } from '@headlessui/react'
import { EllipsisVerticalIcon, CalendarIcon, UserIcon as OutlineUserIcon } from '@heroicons/react/24/outline'
import { BoatIcon, BoatBookingImage, MedicalIcon, PassportIcon } from 'components/icons'
import stSeat from '../../../assets/images/icons/st_seat.svg'
import vipSeat from '../../../assets/images/icons/vip_seat.svg'
import { GET_ALL_BOOKINGS } from 'graphql/booking/queries'
import { useLazyQuery } from '@apollo/client'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { t } from 'i18next'
import loadingImage from 'assets/images/boat-loading.gif'
import {
    customDateFormat,
    customDateTimeFormat,
    customTimeFormat,
    getTimeDifference,
    utcDateTimeToBahrainTime,
    getS3UrlFromKey,
} from 'utils/common'
import { AGE_GROUPS, SEAT_TYPES } from '../../constants'
import { CANCEL_BOOKING } from 'graphql/booking/mutations'
import { useMutation } from '@apollo/client'
import { Badge } from 'components'
import { ErrorDialog, SuccessDialog, ConfirmDialog } from 'components/custom/ResponseDialog'
import { QRCodeCanvas } from 'qrcode.react'
import BoatBookingConformation from '../../boatBooking/confirmation'
import TicketActions from 'components/custom/TicketActions'
import i18n from 'i18next'
import PaymentInfoDialog from 'components/custom/PaymentInfoDialog'
import { ADD_BOOKING_PAYMENT_DETAILS } from 'graphql/booking/mutations'
import { GET_USER_MEMBERSHIP } from 'graphql/membership/queries'
import moment from 'moment'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function formatDuration(minutes) {
    if (!minutes) return ''

    if (minutes < 60) {
        return `${minutes} ${minutes === 1 ? t('minute') : t('minutes')}`
    }

    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60

    if (remainingMinutes === 0) {
        return `${hours} ${hours === 1 ? t('hour') : t('hours')}`
    }

    return `${hours}${t('hr')} ${remainingMinutes}${t('mins')}`
}

function getTripStatusLabel(statusCode) {
    const statusMap = {
        ONP: 'On Trip',
        PND: 'Pending',
        CMP: 'Completed',
        CXL: 'Cancelled',
        NOS: 'No Show',
        TRC: 'Trip Cancelled',
        PRC: 'Processing Payment',
        CNF: 'Confirmed',
        RSC: 'Rescheduled',
    }
    return statusMap[statusCode] || statusCode
}

function getTripStatusColor(statusCode) {
    const colorMap = {
        CNF: 'green',
        ONP: 'blue',
        CMP: 'green',
        CXL: 'red',
        TRC: 'red',
        NOS: 'orange',
        PND: 'yellow',
        PRC: 'yellow',
        RSC: 'red',
    }
    return colorMap[statusCode] || 'zinc'
}

export default function ManageUserMembershipDetail() {
    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const { filterObj, isCheckInMode, fromAppUsers, userEmail, userName, userId } = location.state || {}
    const [bookingInfo, setBookingInfo] = useState(null)
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [dialogMessages, setDialogMessages] = useState('')
    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [confirmDialogMessage, setConfirmDialogMessage] = useState(t('Are you sure you want to cancel this booking?'))
    const [confirmDialogTitle, setConfirmDialogTitle] = useState(t('Cancel Booking'))
    const [showPaymentDialog, setShowPaymentDialog] = useState(false)
    const [showCancellationDialog, setShowCancellationDialog] = useState(false)
    const [selectedTripIds, setSelectedTripIds] = useState([])
    const [cancellationType, setCancellationType] = useState('FULL')
    const [showDocumentPreview, setShowDocumentPreview] = useState(false)
    const [previewDocument, setPreviewDocument] = useState(null)
    const [documentUrl, setDocumentUrl] = useState(null)
    const [bookingList, setBookingList] = useState([])

    const [getBookingList, { loading: bookingListLoading, error: bookingListError }] = useLazyQuery(
        GET_USER_MEMBERSHIP,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data?.getUserSubscriptions?.success && data.getUserSubscriptions.code === '200') {
                    const userSubscriptions = data.getUserSubscriptions.user_subscriptions || []

                    console.log('Returned subscriptions:', userSubscriptions)
                    setBookingInfo(userSubscriptions[0] || null)
                }
            },
            onError: err => {
                console.error('Error fetching user subscriptions:', err)
                setDialogMessages(err.message)
                setShowErrDialog(true)
            },
        }
    )

    const searchBookings = () => {
        getBookingList({
            variables: {
                filter: {
                    user_subscription_id: id,
                    // user_id: null,
                    // subscription_id: null,
                    // status_code: null,
                    // start_date_to: null,
                    // start_date_from: null
                },
                page: { limit: 10, offset: 0 },
            },
        })
    }

    useEffect(() => {
        searchBookings()
    }, [id])

    const handleBack = () => {
        // if (fromAppUsers) {
        //     navigate('/app-users/bookings', { state: { userEmail, userName, userId } })
        // } else if (isCheckInMode) {
        //     navigate('/check-in', { state: { filterObj } })
        if (filterObj) {
            navigate('/user-membership', { state: { filterObj } })
        } else {
            navigate('/user-membership')
        }
    }

    //  MUtation Add Boat
    const [cancelBooking, { loading: cancelLoading }] = useMutation(CANCEL_BOOKING, {
        onCompleted: data => {
            if (data?.cancelBooking.code === '200' && data?.cancelBooking.success === true) {
                setShowSucDialog(true)
                searchBookings() // Refresh the page by calling the initial API again
            } else {
                setDialogMessages(data?.cancelBooking?.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setDialogMessages(error.message)
            setShowErrDialog(true)
        },
    })

    const [addPaymentDetails, { loading: paymentLoading }] = useMutation(ADD_BOOKING_PAYMENT_DETAILS, {
        onCompleted: data => {
            if (data?.addBookingPaymentDetails.code === '200' && data?.addBookingPaymentDetails.success === true) {
                setShowSucDialog(true)
                setDialogMessages(t('Payment details added successfully'))
                setShowPaymentDialog(false)
                searchBookings() // Refresh the data
            } else {
                setDialogMessages(data?.addBookingPaymentDetails.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setDialogMessages(error.message || t('Failed to add payment details'))
            setShowErrDialog(true)
        },
    })

    const handleCancelBooking = () => {
        // Check if booking has multiple trip segments for partial cancellation option
        if (bookingInfo?.trip_segments && bookingInfo.trip_segments.length > 1) {
            setShowCancellationDialog(true)
        } else {
            // Single trip segment - proceed with full cancellation
            setCancellationType('FULL')
            setSelectedTripIds([])
            setConfirmDialogMessage(t('Are you sure you want to cancel this booking?'))
            setConfirmDialogTitle(t('Cancel Booking'))
            setShowConfirmDialog(true)
        }
    }

    const handleTripSelection = tripId => {
        console.log('tripId', tripId)
        setSelectedTripIds(prev => {
            if (prev.includes(tripId)) {
                return prev.filter(id => id !== tripId)
            } else {
                return [...prev, tripId]
            }
        })
    }

    const handleCancellationTypeChange = type => {
        setCancellationType(type)
        if (type === 'FULL') {
            setSelectedTripIds([])
        }
    }

    const proceedWithCancellation = () => {
        setShowCancellationDialog(false)

        if (cancellationType === 'FULL') {
            setConfirmDialogMessage(t('Are you sure you want to cancel this entire booking?'))
            setConfirmDialogTitle(t('Cancel Entire Booking'))
        } else {
            const selectedTripsCount = selectedTripIds.length
            setConfirmDialogMessage(
                t(
                    `Are you sure you want to cancel ${selectedTripsCount} selected trip${selectedTripsCount > 1 ? 's' : ''}?`
                )
            )
            setConfirmDialogTitle(t('Cancel Selected Trips'))
        }

        setShowConfirmDialog(true)
    }

    const handleCheckIn = (segmentId, travelDate) => {
        // Navigate to check-in page with segment information for trip-level check-in
        navigate('/check-in/process', {
            state: {
                bookingInfo: bookingInfo,
                segmentId: segmentId,
                travelDate: travelDate,
                bookingId: id,
            },
        })
    }

    const handlePaymentSubmit = formData => {
        const paymentInfo = {
            no: formData.receiptNumber,
            date: formData.receiptDate,
            currency: 'BHD', // Default currency
            card_no: formData.cardNo,
            card_brand: formData.card_brand, // Default card brand
            amount: parseFloat(formData.amount),
        }

        // Use first segment's travel date if available, otherwise fallback to passengers travel_date (for DYP), metadata travel_date or URL param
        const firstSegmentTravelDate =
            bookingInfo?.trip_segments?.[0]?.travel_date ||
            bookingInfo?.passengers?.[0]?.travel_date ||
            bookingInfo?.metadata?.travel_date ||
            // travel_date

            addPaymentDetails({
                variables: {
                    bookingId: id,
                    travelDate: firstSegmentTravelDate,
                    paymentInfo: paymentInfo,
                },
            })
    }

    // Navigate to reschedule flow for the given segment
    const handleReschedule = segment => {
        if (bookingInfo?.status?.code === 'CXL' || segment?.trip_status === 'CXL' || !segment.reschedule_allowed) return
        navigate('/boat-booking/reschedule', {
            state: {
                bookingId: id,
                bookingInfo: bookingInfo,
                segment: segment,
                tripType: segment.trip_type, // Include trip_type for the searchTrip API
            },
        })
    }

    const GoDetailsPage = (bookingId, travel_date) => {
        // Open in a new tab/window
        window.open(`/manage-boat-booking/details/${bookingId}/${travel_date}/DYP`, '_blank')
    }

    const handleViewDocument = async doc => {
        const url = await getS3UrlFromKey(doc.s3_key)
        if (url) {
            setPreviewDocument(doc)
            setDocumentUrl(url.toString())
            setShowDocumentPreview(true)
        }
    }

    const handleDownloadDocument = async doc => {
        const url = await getS3UrlFromKey(doc.s3_key)
        if (url) {
            const link = document.createElement('a')
            link.href = url.toString()
            link.download = doc.file_name
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }

    const handlePaymentSuccess = apiMessage => {
        setDialogMessages(apiMessage || t('Payment details added successfully'))
        setShowSucDialog(true)
        setShowPaymentDialog(false) // Close the payment dialog
        searchBookings() // Refresh the data
    }

    // Determine if the booking is for a domestic route (DMC)
    const isDomesticRoute = bookingInfo?.trip_segments?.[0]?.route?.master_route?.route_type?.code === 'DMC'

    // Helper function to check if booking is Day Pass type
    const isDayPassBooking = bookingInfo?.booking_type?.code === 'DYP'

    // Helper function to get passengers for display
    const getDisplayPassengers = () => {
        if (isDayPassBooking) {
            return bookingInfo?.passengers || []
        }
        return bookingInfo?.trip_segments?.[0]?.passengers || []
    }

    // Helper function to get travel date
    const getDisplayTravelDate = () => {
        if (isDayPassBooking) {
            return bookingInfo?.passengers?.[0]?.travel_date
        }
        return bookingInfo?.trip_segments?.[0]?.travel_date || bookingInfo?.metadata?.travel_date
    }

    return (
        <>
            <div id="manage_page_back" className="mb-4 flex justify-normal items-center">
                <div className="flex flex-wrap items-center gap-3 sm:flex-nowrap justify-between">
                    <button
                        onClick={handleBack}
                        type="button"
                        className="inline-flex items-center gap-x-0.5 rounded-md text-sm text-gray-600"
                    >
                        <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-4 rtl:rotate-180" />
                        {t('Back')}
                    </button>
                    <h3 className="text-lg font-bold leading-7 text-primary pb-1">{t('Subscription details')}</h3>
                </div>
            </div>

            {bookingListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">Loading, please wait...</p>
                </div>
            )}
            {bookingListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch boat!')}</div>
                </div>
            )}
            {!bookingListLoading && !bookingListError && !bookingInfo && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No Booking found!')}</div>
                </div>
            )}
            {bookingInfo && !bookingListLoading && (
                <>
                    <div id="manage_page" className="grid grid-cols-1 md:grid-cols-6 gap-4 p-4">
                        <div
                            className={`flex flex-col ${bookingInfo?.trip_segments && !isDayPassBooking ? 'col-span-4' : 'col-span-6'} gap-4`}
                        >
                            {/* Booking Header */}
                            <div className="bg-white relative rounded-lg border border-slate-300 p-6">
                                <div className="flex justify-between flex-col lg:flex-row gap-6">
                                    <div className="flex items-center gap-4">
                                        <IdentificationIcon className="w-[50px] h-[50px] text-white rounded-full bg-primary p-3" />
                                        <div className="min-w-0 flex-1">
                                            <h2 className="text-xl font-bold break-words">
                                                {bookingInfo?.subscription_plan?.subscription_name?.en}
                                            </h2>
                                            <p className="text-[14px] text-gray-700 sm:mt-2 break-words">
                                                {bookingInfo?.subscription_plan?.description?.en}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="text-end flex flex-col justify-end">
                                        <p className="text-sm text-gray-600">
                                            {t('Membership Status')} :{' '}
                                            <Badge
                                                color={
                                                    bookingInfo?.status === 'CNF'
                                                        ? 'emerald'
                                                        : bookingInfo?.status === 'PRC'
                                                          ? 'lime'
                                                          : bookingInfo?.status === 'CXL'
                                                            ? 'red'
                                                            : bookingInfo?.status === 'CMP'
                                                              ? 'emerald'
                                                              : 'zinc'
                                                }
                                                className="text-end w-fit mb-3"
                                            >
                                                {getTripStatusLabel(bookingInfo?.status)}
                                            </Badge>
                                        </p>

                                        {bookingInfo?.status === 'CNF' && (
                                            <button
                                                // onClick={handleCancelBooking}
                                                className="hover:bg-red/80 mt-0 bg-red justify-center rounded-md px-3 py-2 w-auto text-sm font-semibold leading-6 text-white shadow-sm"
                                            >
                                                {t('Cancel Membership')}
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* Subscription Info */}
                                <div className="bg-[#F4F7F8] rounded-sm p-4 mb-4">
                                    <div className="grid grid-cols-1 md:grid-cols-3 text-center text-sm gap-y-4 md:gap-y-6 text-gray-600">
                                        {/* Start Date */}
                                        <div className="flex">
                                            <CalendarIcon className="w-5 h-5 mb-1 text-[#285f74]" />
                                            <div className="ps-3 text-start">
                                                <p className="pb-1">{t('Start Date')}</p>
                                                <p className="font-bold text-[16px]">
                                                    {bookingInfo?.start_date
                                                        ? moment(bookingInfo.start_date).format('DD MMM YYYY')
                                                        : 'N/A'}
                                                </p>
                                            </div>
                                        </div>

                                        {/* End Date */}
                                        <div className="flex">
                                            <CalendarIcon className="w-5 h-5 mb-1 text-[#285f74]" />
                                            <div className="ps-3 text-start">
                                                <p className="pb-1">{t('End Date')}</p>
                                                <p className="font-bold text-[16px]">
                                                    {bookingInfo?.end_date
                                                        ? moment(bookingInfo.end_date).format('DD MMM YYYY')
                                                        : 'N/A'}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Remaining Days */}
                                        <div className="flex">
                                            <ClockIcon className="w-5 h-5 mb-1 text-[#285f74]" />
                                            <div className="ps-3 text-start">
                                                <p className="pb-1">{t('Remaining Days')}</p>
                                                <p
                                                    className={`font-bold text-[16px] ${
                                                        bookingInfo?.days_remaining > 0
                                                            ? 'text-green-600'
                                                            : 'text-red-500'
                                                    }`}
                                                >
                                                    {bookingInfo?.days_remaining ?? 0} {t('Days')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 lg:grid-cols-1 gap-12">
                                    <div>
                                        <div className="text-gray-700 mb-2">
                                            <p className="font-md font-bold mb-4 border-b border-slate-100 pb-2">
                                                {t('Subscription Information')}
                                            </p>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-0">
                                                <div className="flex flex-col justify-between gap-y-1">
                                                    <p className="text-sm text-gray-600">{t('Member')}</p>
                                                    <p className="text-sm font-semibold text-gray-600 break-words">
                                                        {bookingInfo.user
                                                            ? bookingInfo.user?.user_info?.given_name
                                                            : bookingInfo.user_id}
                                                    </p>
                                                </div>

                                                <div className="flex flex-col justify-between gap-y-1">
                                                    {/* Period */}
                                                    <p className="text-sm text-gray-600">{t('Period')}</p>
                                                    <p className="text-sm font-semibold text-gray-600">
                                                        {bookingInfo.subscription_plan?.period?.description?.[
                                                            i18n?.language || 'en'
                                                        ] ?? <span className="italic text-gray-300">N/A</span>}
                                                    </p>
                                                </div>

                                                <div className="flex flex-col justify-between gap-y-1">
                                                    {/* Category */}
                                                    <p className="text-sm text-gray-600">{t('Category')}</p>
                                                    <p className="text-sm font-semibold text-gray-600">
                                                        {bookingInfo.subscription_plan.category_code ?? (
                                                            <span className="italic text-gray-300">N/A</span>
                                                        )}
                                                    </p>
                                                </div>

                                                <div className="flex flex-col justify-between gap-y-1">
                                                    <p className="text-sm text-gray-600">{t('Created On')}</p>
                                                    <p className="text-sm font-semibold text-gray-600">
                                                        {bookingInfo?.user_audit?.created_date ? (
                                                            customDateTimeFormat(bookingInfo.user_audit.created_date)
                                                        ) : (
                                                            <span className="italic text-gray-300"> N/A</span>
                                                        )}
                                                    </p>
                                                </div>

                                                <div className="flex flex-col gap-y-1">
                                                    <p className="text-sm text-gray-600">{t('Created By')}</p>
                                                    <p className="text-sm font-semibold text-gray-600">
                                                        {bookingInfo?.user_audit?.created_by ? (
                                                            bookingInfo.user_audit.created_by
                                                        ) : (
                                                            <span className="italic text-gray-400">N/A</span>
                                                        )}
                                                    </p>
                                                </div>

                                                {/* Route */}
                                                <div className="flex flex-col gap-y-1">
                                                    <p className="text-sm text-gray-600">{t('Route')}</p>
                                                    <div className="text-sm font-semibold text-gray-600 flex flex-col">
                                                        {bookingInfo.subscription_plan?.routes?.length > 0 ? (
                                                            bookingInfo.subscription_plan.routes.map((route, index) => (
                                                                <span key={index}>
                                                                    {route.route_name?.[
                                                                        i18n?.language?.toLowerCase() || 'en'
                                                                    ] ?? 'N/A'}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="italic text-gray-400">N/A</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Membership Details Card */}
                            <div className="bg-white rounded-lg border-[1px] border-solid border-slate-300 p-4 mt-3">
                                <div className="text-gray-700">
                                    {/* Header */}
                                    <div className="flex justify-between border-b border-slate-200 items-center w-full pb-2 mb-3">
                                        <div className="flex items-center gap-2">
                                            <h3 className="text-base font-bold text-gray-900">
                                                {t('Membership Benefits')}
                                            </h3>
                                            {bookingInfo?.user_id && (
                                                <div className="flex items-center gap-1 text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                                                    <SparklesIcon className="w-5 h-5" />
                                                    <span className="font-medium"></span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Benefits Grid */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                        {/* Number of Trips */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <TicketIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Number of Trips')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.benefits?.number_of_trips ?? (
                                                        <span className="italic text-gray-400">N/A</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Discount */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <PercentBadgeIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Discount')}</p>
                                                <p className="text-xs font-semibold text-primary">
                                                    {bookingInfo.subscription_plan?.benefits?.discount_percentage ? (
                                                        `${bookingInfo.subscription_plan.benefits.discount_percentage}%`
                                                    ) : (
                                                        <span className="italic text-gray-400">N/A</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Unlimited Trips */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <ArrowPathIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Unlimited Trips')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.benefits?.unlimited_trips
                                                        ? t('Yes')
                                                        : t('No')}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Free Luggage */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <BriefcaseIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Free Luggage (kg)')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.benefits?.free_luggage_kg ?? (
                                                        <span className="italic text-gray-400">N/A</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Membership Metadata Card */}
                            <div className="bg-white rounded-lg border-[1px] border-solid border-slate-300 p-4 mt-3">
                                <div className="text-gray-700">
                                    {/* Header */}
                                    <div className="flex justify-between border-b border-slate-200 items-center w-full pb-2 mb-3">
                                        <div className="flex items-center gap-2">
                                            <h3 className="text-base font-bold text-gray-900">
                                                {t('Membership Eligibility')}
                                            </h3>
                                            {bookingInfo?.user_id && (
                                                <div className="flex items-center gap-1 text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                                                    <ShieldCheckIcon className="w-5 h-5" />
                                                    <span className="font-medium"></span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Metadata Grid */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                        {/* Promo Code */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <TicketIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Promo Code')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.metadata?.promo_code ?? (
                                                        <span className="italic text-gray-400">N/A</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Max Subscribers */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <UserIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Max Subscribers')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.metadata?.max_subscribers ?? (
                                                        <span className="italic text-gray-400">N/A</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Featured */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <StarIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Featured')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.metadata?.featured
                                                        ? t('Yes')
                                                        : t('No')}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Terms & Conditions */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <DocumentTextIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Terms & Conditions')}</p>
                                                <p className="text-xs font-medium text-gray-900 break-words">
                                                    {bookingInfo.subscription_plan?.metadata?.terms_conditions?.[
                                                        i18n?.language?.toLowerCase() || 'en'
                                                    ] ?? <span className="italic text-gray-400">N/A</span>}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Auto Renew */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <ArrowPathIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Auto Renew')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.metadata?.auto_renew
                                                        ? t('Yes')
                                                        : t('No')}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Active Status */}
                                        <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                            <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-xs text-gray-500">{t('Active')}</p>
                                                <p className="text-xs font-medium text-gray-900">
                                                    {bookingInfo.subscription_plan?.is_active ? t('Yes') : t('No')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Day Pass Passengers */}
                                    {isDayPassBooking && bookingInfo?.passengers && (
                                        <div className="space-y-3">
                                            <div className="space-y-2">
                                                {bookingInfo.passengers.map((person, idx) => (
                                                    <div
                                                        key={person.passenger_id}
                                                        className="bg-gray-50 rounded p-3 border border-gray-200"
                                                    >
                                                        {/* Passenger Header */}
                                                        <div className="flex items-center justify-between mb-2">
                                                            <div className="flex items-center gap-2">
                                                                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                                                                    <UserIcon className="w-5 h-5 text-primary" />
                                                                </div>
                                                                <div className="min-w-0 flex-1">
                                                                    <h4 className="text-sm font-semibold text-gray-900 break-words">
                                                                        {person.passenger.given_name}{' '}
                                                                        {person.passenger.family_name}
                                                                    </h4>
                                                                    <p className="text-xs text-gray-600">
                                                                        {AGE_GROUPS[person.passenger.age_group_code] ||
                                                                            person.passenger.age_group_code}
                                                                        {person.passenger.special_needs && (
                                                                            <span className="ml-2 text-orange-600 font-medium">
                                                                                • {t('Special Needs')}
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="text-right">
                                                                <p className="text-xs font-medium text-gray-600">
                                                                    {t('Ticket No')}
                                                                </p>
                                                                <p className="text-xs font-mono font-semibold text-primary">
                                                                    {person.ticket_number}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        {/* Contact Information */}
                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
                                                            <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                                                <PhoneIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                                                <div className="min-w-0 flex-1">
                                                                    <p className="text-xs text-gray-500">
                                                                        {t('Phone')}
                                                                    </p>
                                                                    <p className="text-xs font-medium text-gray-900 break-all">
                                                                        {person.passenger.phone_number || (
                                                                            <span className="italic text-gray-400">
                                                                                N/A
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                                                                <ChatBubbleBottomCenterIcon className="w-5 h-5 text-primary flex-shrink-0" />
                                                                <div className="min-w-0 flex-1">
                                                                    <p className="text-xs text-gray-500">
                                                                        {t('Email')}
                                                                    </p>
                                                                    {/* <p className="text-xs font-medium text-gray-900 break-all">
                                                                        {boo.user_id || (
                                                                            <span className="italic text-gray-400">N/A</span>
                                                                        )}
                                                                    </p> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="bg-white rounded-lg border-[1px] border-solid border-slate-300 p-6 mt-5 pt-2 pb-0">
                                <div className="text-gray-700 mt-2">
                                    <div className="flex justify-between border-b border-slate-100 items-center w-full pb-2">
                                        <p className="font-md font-bold">{t('Payment Info')}</p>
                                        {bookingInfo?.status?.code === 'CNF' && bookingInfo.user_id === 'Admin' && (
                                            <button
                                                type="button"
                                                className="flex items-center underline gap-x-1 py-1.5 text-sm font-bold leading-6 text-primary"
                                                onClick={() => setShowPaymentDialog(true)}
                                            >
                                                <PlusCircleIcon aria-hidden="true" className="h-5 w-5" />
                                                {t('Add Payment Info')}
                                            </button>
                                        )}
                                    </div>

                                    <div className="flex flex-row gap-6">
                                        <ul className="w-full">
                                            {/* Transaction ID */}
                                            <li className="my-4 px-1">
                                                <div className="flex gap-4 w-full justify-between">
                                                    <p className="text-sm text-gray-600">Transaction ID</p>
                                                    <p className="text-[14px] font-[500] lg:text-end">
                                                        {bookingInfo.payment_info?.transaction_id ?? (
                                                            <span className="italic font-semibold text-gray-300">
                                                                N/A
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </li>

                                            {/* Payment Method */}
                                            <li className="my-4 px-1">
                                                <div className="flex gap-4 w-full justify-between">
                                                    <p className="text-sm text-gray-600">Payment Method</p>
                                                    <p className="text-[14px] font-[500] lg:text-end">
                                                        {bookingInfo.payment_info?.payment_method ?? (
                                                            <span className="italic font-semibold text-gray-300">
                                                                N/A
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </li>

                                            {/* Amount Paid */}
                                            <li className="my-4 px-1">
                                                <div className="flex gap-4 w-full justify-between">
                                                    <p className="text-sm text-gray-600">Amount Paid</p>
                                                    <p className="text-[14px] font-[500] lg:text-end">
                                                        {bookingInfo.payment_info?.amount_paid ? (
                                                            `${bookingInfo.payment_info.amount_paid} ${bookingInfo.payment_info.currency || ''}`
                                                        ) : (
                                                            <span className="italic font-semibold text-gray-300">
                                                                N/A
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </li>

                                            {/* Payment Date */}
                                            <li className="my-4 px-1">
                                                <div className="flex gap-4 w-full justify-between">
                                                    <p className="text-sm text-gray-600">Payment Date</p>
                                                    <p className="text-[14px] font-[500] lg:text-end">
                                                        {bookingInfo.payment_info?.payment_date ? (
                                                            customDateFormat(bookingInfo.payment_info.payment_date)
                                                        ) : (
                                                            <span className="italic font-semibold text-gray-300">
                                                                N/A
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Total Section */}
                                <div className="pt-1 pb-0 ml-[-23px] mr-[-23px]">
                                    <div className="bg-[#F4F7F8] text-black py-3 px-4 rounded-lg flex justify-between items-center mt-[-5px]">
                                        <p className="font-semibold ps-3">{t('Total Amount')}</p>
                                        <p className="font-bold text-[19px] pe-3">
                                            {bookingInfo.price?.final_price || bookingInfo.total_price
                                                ? Number(
                                                      bookingInfo.price?.final_price || bookingInfo.total_price
                                                  ).toFixed(2)
                                                : '0.00'}{' '}
                                            {bookingInfo.receipt?.currency || 'BHD'}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Refund Details Section - Show for cancelled trips */}
                            {bookingInfo?.trip_segments &&
                                bookingInfo.trip_segments.some(
                                    segment =>
                                        (segment.trip_status === 'CXL' || segment.trip_status === 'TRC') &&
                                        segment.refund?.segment_id
                                ) && (
                                    <div className="bg-white rounded-lg border-[1px] border-solid border-slate-300 p-6 mt-5 pt-2 pb-0">
                                        <div className="text-gray-700 mt-2">
                                            <div className="flex justify-between border-b border-slate-100 items-center w-full pb-2">
                                                <p className="font-md font-bold">{t('Refund Details')}</p>
                                            </div>

                                            {bookingInfo.trip_segments.map((segment, segmentIndex) => {
                                                // Only show refund details for cancelled trips with valid refund data
                                                if (
                                                    (segment.trip_status !== 'CXL' && segment.trip_status !== 'TRC') ||
                                                    !segment.refund?.segment_id
                                                ) {
                                                    return null
                                                }

                                                const refund = segment.refund

                                                return (
                                                    <div key={segment.segment_id}>
                                                        {/* Trip Header for multi-segment bookings */}
                                                        {bookingInfo.trip_segments.length > 1 && (
                                                            <div className="flex items-center gap-2 mt-4 mb-2">
                                                                <div className="w-6 h-6 bg-primary/20 rounded-full flex items-center justify-center">
                                                                    <span className="text-xs font-bold text-red-600">
                                                                        {segmentIndex + 1}
                                                                    </span>
                                                                </div>
                                                                <p className="text-sm font-semibold text-gray-800">
                                                                    {segmentIndex === 0 ? t('Trip') : t('Trip')}
                                                                </p>
                                                                <Badge color="red" className="ml-auto">
                                                                    {getTripStatusLabel(segment.trip_status)}
                                                                </Badge>
                                                            </div>
                                                        )}

                                                        <div className="flex flex-row gap-6">
                                                            <ul className="w-full">
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Trip Price')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.trip_price?.toFixed(2) || '0.00'}{' '}
                                                                            BHD
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Refundable Base')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.refundable_base?.toFixed(2) ||
                                                                                '0.00'}{' '}
                                                                            BHD
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Policy Applied')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.policy_applied?.replace(
                                                                                /_/g,
                                                                                ' '
                                                                            ) || (
                                                                                <span className="italic font-semibold text-gray-300">
                                                                                    N/A
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Policy Percent')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.policy_percent != null ? (
                                                                                `${refund.policy_percent}%`
                                                                            ) : (
                                                                                <span className="italic font-semibold text-gray-300">
                                                                                    N/A
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Penalty Amount')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end text-orange-600">
                                                                            {refund.penalty_amount?.toFixed(2) ||
                                                                                '0.00'}{' '}
                                                                            BHD
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Cancelled At')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.cancelled_at ? (
                                                                                customDateTimeFormat(
                                                                                    refund.cancelled_at
                                                                                )
                                                                            ) : (
                                                                                <span className="italic font-semibold text-gray-300">
                                                                                    N/A
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Trip Departure Time')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.trip_departure_time ? (
                                                                                customDateTimeFormat(
                                                                                    refund.trip_departure_time
                                                                                )
                                                                            ) : (
                                                                                <span className="italic font-semibold text-gray-300">
                                                                                    N/A
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="my-4 px-1">
                                                                    <div className="flex gap-4 w-full justify-between">
                                                                        <p className="text-sm text-gray-600">
                                                                            {t('Hours Before Trip')}
                                                                        </p>
                                                                        <p className="text-[14px] font-[500] lg:text-end">
                                                                            {refund.hours_before_trip != null ? (
                                                                                `${refund.hours_before_trip.toFixed(2)} ${t('hours')}`
                                                                            ) : (
                                                                                <span className="italic font-semibold text-gray-300">
                                                                                    N/A
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                {refund.remarks && (
                                                                    <li className="my-4 px-1">
                                                                        <div className="flex gap-4 w-full justify-between">
                                                                            <p className="text-sm text-gray-600">
                                                                                {t('Remarks')}
                                                                            </p>
                                                                            <p className="text-[14px] font-[500] lg:text-end text-primary">
                                                                                {refund.remarks}
                                                                            </p>
                                                                        </div>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>

                                                        {/* Refund Amount Total Section */}
                                                        <div className="pt-1 pb-0 ml-[-23px] mr-[-23px]">
                                                            <div className="bg-[#F4F7F8] text-black py-3 px-4 rounded-lg flex justify-between items-center mt-[-5px]">
                                                                <p className="font-semibold ps-3 text-green-700">
                                                                    {t('Refund Amount')}
                                                                </p>
                                                                <p className="font-bold text-[19px] pe-3 text-green-700">
                                                                    {refund.refund_amount?.toFixed(2) || '0.00'} BHD
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            {bookingInfo?.trip_segments && bookingInfo?.trip_segments[0]?.trip_locations.length > 0 && (
                                <div className="col-span-2 bg-white rounded-lg border-[1px] border-solid border-slate-300 p-6 mt-5 h-fit">
                                    <div>
                                        <p className="font-md font-bold mb-4 border-b border-slate-100 pb-2">
                                            {t('Trip Info')}
                                        </p>

                                        {bookingInfo?.trip_segments && bookingInfo.trip_segments.length > 1 ? (
                                            // Return Trip Layout
                                            <div className="space-y-6">
                                                {/* Departure Trip Info */}
                                                <div>
                                                    <div className="flex items-center gap-2 mb-4">
                                                        <div className="w-6 h-6 bg-primary/20 rounded-full flex items-center justify-center">
                                                            <span className="text-xs font-bold text-primary">1</span>
                                                        </div>
                                                        <h4 className="text-sm font-semibold text-gray-800">
                                                            {t('Departure Trip')}
                                                        </h4>
                                                        <div className="flex-1 h-px bg-gray-300"></div>
                                                        <span className="text-xs text-gray-500">
                                                            {customDateFormat(bookingInfo.trip_segments[0].travel_date)}
                                                        </span>
                                                    </div>
                                                    <div className="flow-root mt-4">
                                                        <ul className="-mb-8">
                                                            {bookingInfo.trip_segments[0]?.trip_locations.map(
                                                                (sch, scheduleIdx) => (
                                                                    <li key={sch.location_id}>
                                                                        <div className="relative pb-4">
                                                                            {scheduleIdx !==
                                                                            (
                                                                                bookingInfo.trip_segments[0]
                                                                                    ?.trip_locations ?? []
                                                                            ).length -
                                                                                1 ? (
                                                                                <span
                                                                                    aria-hidden="true"
                                                                                    className="absolute left-2 top-4 -ml-px h-full w-0.5 bg-gray-200"
                                                                                />
                                                                            ) : null}
                                                                            <div className="relative flex space-x-3">
                                                                                <div>
                                                                                    <span
                                                                                        className={classNames(
                                                                                            'bg-white',
                                                                                            'flex h-4 w-4 items-center justify-center rounded-full ring-1 ring-primary border-solid border-2  border-primary'
                                                                                        )}
                                                                                    ></span>
                                                                                </div>
                                                                                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-0 border-solid border-b-2 border-gray-100 pb-4 last:border-0">
                                                                                    <div className="mt-[-5px]">
                                                                                        <p className="text-md font-medium text-gray-900 break-words">
                                                                                            {sch.location.name.en}
                                                                                        </p>
                                                                                        {scheduleIdx === 0 &&
                                                                                            bookingInfo.trip_segments[0]
                                                                                                ?.duration_minutes && (
                                                                                                <p className="flex text-sm font-medium text-gray-900 pt-2">
                                                                                                    <InformationCircleIcon
                                                                                                        aria-hidden="true"
                                                                                                        className="h-5 w-5 text-primary font-[12px] me-1"
                                                                                                    />{' '}
                                                                                                    {formatDuration(
                                                                                                        bookingInfo
                                                                                                            .trip_segments[0]
                                                                                                            ?.duration_minutes
                                                                                                    )}{' '}
                                                                                                </p>
                                                                                            )}
                                                                                    </div>
                                                                                    <div className="whitespace-nowrap text-right text-sm text-gray-500">
                                                                                        <time dateTime={''}>{''}</time>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* Return Trip Info */}
                                                <div>
                                                    <div className="flex items-center gap-2 mb-4">
                                                        <div className="w-6 h-6 bg-primary/20 rounded-full flex items-center justify-center">
                                                            <span className="text-xs font-bold text-primary">2</span>
                                                        </div>
                                                        <h4 className="text-sm font-semibold text-gray-800">
                                                            {t('Return Trip')}
                                                        </h4>
                                                        <div className="flex-1 h-px bg-gray-300"></div>
                                                        <span className="text-xs text-gray-500">
                                                            {customDateFormat(bookingInfo.trip_segments[1].travel_date)}
                                                        </span>
                                                    </div>
                                                    <div className="flow-root mt-4">
                                                        <ul className="-mb-8">
                                                            {bookingInfo.trip_segments[1]?.trip_locations.map(
                                                                (sch, scheduleIdx) => (
                                                                    <li key={sch.location_id}>
                                                                        <div className="relative pb-4">
                                                                            {scheduleIdx !==
                                                                            (
                                                                                bookingInfo.trip_segments[1]
                                                                                    ?.trip_locations ?? []
                                                                            ).length -
                                                                                1 ? (
                                                                                <span
                                                                                    aria-hidden="true"
                                                                                    className="absolute left-2 top-4 -ml-px h-full w-0.5 bg-gray-200"
                                                                                />
                                                                            ) : null}
                                                                            <div className="relative flex space-x-3">
                                                                                <div>
                                                                                    <span
                                                                                        className={classNames(
                                                                                            'bg-white',
                                                                                            'flex h-4 w-4 items-center justify-center rounded-full ring-1 ring-primary border-solid border-2  border-primary'
                                                                                        )}
                                                                                    ></span>
                                                                                </div>
                                                                                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-0 border-solid border-b-2 border-gray-100 pb-4 last:border-0">
                                                                                    <div className="mt-[-5px]">
                                                                                        <p className="text-md font-medium text-gray-900 break-words">
                                                                                            {sch.location.name.en}
                                                                                        </p>
                                                                                        {scheduleIdx === 0 &&
                                                                                            bookingInfo.trip_segments[1]
                                                                                                ?.duration_minutes && (
                                                                                                <p className="flex text-sm font-medium text-gray-900 pt-2">
                                                                                                    <InformationCircleIcon
                                                                                                        aria-hidden="true"
                                                                                                        className="h-5 w-5 text-primary font-[12px] me-1"
                                                                                                    />{' '}
                                                                                                    {formatDuration(
                                                                                                        bookingInfo
                                                                                                            .trip_segments[1]
                                                                                                            ?.duration_minutes
                                                                                                    )}{' '}
                                                                                                </p>
                                                                                            )}
                                                                                    </div>
                                                                                    <div className="whitespace-nowrap text-right text-sm text-gray-500">
                                                                                        <time dateTime={''}>{''}</time>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            // Single Trip Layout (Original)
                                            <div className="flow-root mt-4">
                                                <ul className="-mb-8">
                                                    {bookingInfo.trip_segments[0]?.trip_locations.map(
                                                        (sch, scheduleIdx) => (
                                                            <li key={sch.location_id}>
                                                                <div className="relative pb-4">
                                                                    {scheduleIdx !==
                                                                    (bookingInfo.trip_segments[0]?.trip_locations ?? [])
                                                                        .length -
                                                                        1 ? (
                                                                        <span
                                                                            aria-hidden="true"
                                                                            className="absolute left-2 top-4 -ml-px h-full w-0.5 bg-gray-200"
                                                                        />
                                                                    ) : null}
                                                                    <div className="relative flex space-x-3">
                                                                        <div>
                                                                            <span
                                                                                className={classNames(
                                                                                    'bg-white',
                                                                                    'flex h-4 w-4 items-center justify-center rounded-full ring-1 ring-primary border-solid border-2  border-primary'
                                                                                )}
                                                                            ></span>
                                                                        </div>
                                                                        <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-0 border-solid border-b-2 border-gray-100 pb-4 last:border-0">
                                                                            <div className="mt-[-5px]">
                                                                                <p className="text-md font-medium text-gray-900">
                                                                                    {sch.location.name.en}
                                                                                </p>
                                                                                {scheduleIdx === 0 &&
                                                                                    bookingInfo.trip_segments[0]
                                                                                        ?.duration_minutes && (
                                                                                        <p className="flex text-sm font-medium text-gray-900 pt-2">
                                                                                            <InformationCircleIcon
                                                                                                aria-hidden="true"
                                                                                                className="h-5 w-5 text-primary font-[12px] me-1"
                                                                                            />{' '}
                                                                                            {formatDuration(
                                                                                                bookingInfo
                                                                                                    .trip_segments[0]
                                                                                                    ?.duration_minutes
                                                                                            )}{' '}
                                                                                        </p>
                                                                                    )}
                                                                            </div>
                                                                            <div className="whitespace-nowrap text-right text-sm text-gray-500">
                                                                                <time dateTime={''}>{''}</time>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {showConfirmDialog && (
                <ConfirmDialog
                    status={true}
                    title={confirmDialogTitle}
                    negativeActionText={t('Cancel')}
                    positiveActionText={t('Yes')}
                    message={confirmDialogMessage}
                    onPositive={() => {
                        setShowConfirmDialog(false)
                        cancelBooking({
                            variables: {
                                bookingId: id,
                                cancellationType: cancellationType,
                                tripIds: cancellationType === 'PARTIAL' ? selectedTripIds : [],
                            },
                        })
                    }}
                    onNegative={() => {
                        setShowConfirmDialog(false)
                    }}
                />
            )}
            {showSucDialog && (
                <SuccessDialog
                    status={true}
                    title="Success"
                    message={dialogMessages}
                    onClose={() => setShowSucDialog(false)}
                />
            )}
            {showErrDialog && (
                <ErrorDialog
                    status={true}
                    title="Error"
                    message={dialogMessages}
                    onClose={() => setShowErrDialog(false)}
                />
            )}
            <PaymentInfoDialog
                open={showPaymentDialog}
                onClose={() => setShowPaymentDialog(false)}
                bookingData={bookingInfo}
                onSuccess={handlePaymentSuccess}
            />

            {/* Cancellation Type Selection Dialog */}
            {showCancellationDialog && (
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        <div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all w-full max-w-md">
                            {/* Header */}
                            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                                <h3 className="text-lg font-semibold text-gray-900">{t('Select Cancellation Type')}</h3>
                                <button
                                    type="button"
                                    className="text-gray-400 hover:text-gray-600"
                                    onClick={() => setShowCancellationDialog(false)}
                                >
                                    <XMarkIcon className="h-6 w-6" />
                                </button>
                            </div>

                            {/* Content */}
                            <div className="px-6 py-6">
                                <p className="text-sm text-gray-600 mb-6">
                                    {t('This booking has multiple trips. Choose how you want to cancel:')}
                                </p>

                                {/* Cancellation Type Selection */}
                                <div className="space-y-4 mb-6">
                                    <label className="flex items-start cursor-pointer">
                                        <input
                                            type="radio"
                                            name="cancellationType"
                                            value="FULL"
                                            checked={cancellationType === 'FULL'}
                                            onChange={e => handleCancellationTypeChange(e.target.value)}
                                            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 mt-0.5"
                                        />
                                        <div className="ml-3">
                                            <div className="text-sm font-medium text-gray-900">
                                                {t('Cancel Entire Booking')}
                                            </div>
                                            <div className="text-xs text-gray-500 mt-1">
                                                {t('Cancel all trips in this booking')}
                                            </div>
                                        </div>
                                    </label>
                                    <label className="flex items-start cursor-pointer">
                                        <input
                                            type="radio"
                                            name="cancellationType"
                                            value="PARTIAL"
                                            checked={cancellationType === 'PARTIAL'}
                                            onChange={e => handleCancellationTypeChange(e.target.value)}
                                            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 mt-0.5"
                                        />
                                        <div className="ml-3">
                                            <div className="text-sm font-medium text-gray-900">
                                                {t('Cancel Selected Trips')}
                                            </div>
                                            <div className="text-xs text-gray-500 mt-1">
                                                {t('Choose specific trips to cancel')}
                                            </div>
                                        </div>
                                    </label>
                                </div>

                                {/* Trip Selection for Partial Cancellation */}
                                {/* {cancellationType === 'PARTIAL' && (
                                    <div className="border-t border-gray-200 pt-6">
                                        <h4 className="text-sm font-medium text-gray-900 mb-4">
                                            {t('Select trips to cancel:')}
                                        </h4>
                                        <div className="space-y-3 max-h-60 overflow-y-auto">
                                            {bookingInfo?.trip_segments?.map((segment, index) => (
                                                <div
                                                    key={segment.trip_id}
                                                    className={`flex items-start p-3 rounded-lg border border-gray-200 ${
                                                        segment.trip_status === 'CXL'
                                                            ? 'bg-gray-100 cursor-not-allowed opacity-60'
                                                            : 'hover:bg-gray-50 cursor-pointer'
                                                    }`}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedTripIds.includes(segment.trip_id)}
                                                        onChange={() => handleTripSelection(segment.trip_id)}
                                                        disabled={segment.trip_status === 'CXL'}
                                                        className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded mt-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
                                                    />
                                                    <div className="ml-3 flex-1">
                                                        <div className="flex items-center gap-2">
                                                            <span className="text-sm font-medium text-gray-900">
                                                                {t('Trip')} {segment.segment_order}
                                                            </span>
                                                            {segment.trip_status === 'CXL' && (
                                                                <Badge color="red" className="text-xs">
                                                                    {t('Cancelled')}
                                                                </Badge>
                                                            )}
                                                        </div>
                                                        <div className="text-xs text-gray-500 mt-1">
                                                            {customDateFormat(segment.travel_date)} -{' '}
                                                            {segment.start.location.name.en} to{' '}
                                                            {segment.end.location.name.en}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        {(() => {
                                            const availableTrips =
                                                bookingInfo?.trip_segments?.filter(
                                                    segment => segment.trip_status !== 'CXL'
                                                ) || []
                                            const hasSelectedTrips = selectedTripIds.length > 0
                                            const hasAvailableTrips = availableTrips.length > 0

                                            if (!hasSelectedTrips && hasAvailableTrips) {
                                                return (
                                                    <p className="text-xs text-red-500 mt-3 flex items-center">
                                                        <XMarkIcon className="h-4 w-4 mr-1" />
                                                        {t('Please select at least one trip to cancel')}
                                                    </p>
                                                )
                                            }
                                            return null
                                        })()}
                                    </div>
                                )} */}
                            </div>

                            {/* Footer */}
                            <div className="flex justify-end gap-3 px-6 py-4 bg-gray-50 border-t border-gray-200">
                                <button
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    onClick={() => setShowCancellationDialog(false)}
                                >
                                    {t('Cancel')}
                                </button>
                                <button
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:opacity-50"
                                    style={{ backgroundColor: 'rgb(40 95 116 / var(--tw-bg-opacity, 1))' }}
                                    onClick={proceedWithCancellation}
                                    disabled={
                                        cancellationType === 'PARTIAL' &&
                                        (() => {
                                            const availableTrips =
                                                bookingInfo?.trip_segments?.filter(
                                                    segment => segment.trip_status !== 'CXL'
                                                ) || []
                                            return availableTrips.length > 0 && selectedTripIds.length === 0
                                        })()
                                    }
                                >
                                    {t('Proceed')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Document Preview Dialog */}
            {showDocumentPreview && previewDocument && (
                <div
                    className="fixed inset-0 z-50 overflow-y-auto"
                    aria-labelledby="modal-title"
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div
                            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                            aria-hidden="true"
                            onClick={() => setShowDocumentPreview(false)}
                        ></div>

                        {/* Center modal */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>

                        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
                            {/* Header */}
                            <div className="bg-white px-4 py-3 border-b border-gray-200 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <DocumentIcon className="h-6 w-6 text-primary" />
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900" id="modal-title">
                                            {t('Document Preview')}
                                        </h3>
                                        <p className="text-sm text-gray-500 truncate max-w-md">
                                            {previewDocument.file_name}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => handleDownloadDocument(previewDocument)}
                                        className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    >
                                        <ArrowDownTrayIcon className="h-4 w-4" />
                                        {t('Download')}
                                    </button>
                                    <button
                                        onClick={() => setShowDocumentPreview(false)}
                                        className="text-gray-400 hover:text-gray-500 focus:outline-none"
                                    >
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="bg-gray-100 px-4 py-6" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                {previewDocument.mime_type?.startsWith('image/') ? (
                                    <div className="flex justify-center">
                                        <img
                                            src={documentUrl}
                                            alt={previewDocument.file_name}
                                            className="max-w-full h-auto rounded shadow-lg"
                                        />
                                    </div>
                                ) : previewDocument.mime_type === 'application/pdf' ? (
                                    <iframe
                                        src={documentUrl}
                                        className="w-full rounded shadow-lg"
                                        style={{ height: '65vh' }}
                                        title={previewDocument.file_name}
                                    />
                                ) : (
                                    <div className="text-center py-12">
                                        <DocumentIcon className="mx-auto h-12 w-12 text-gray-400" />
                                        <h3 className="mt-2 text-sm font-medium text-gray-900">
                                            {t('Preview not available')}
                                        </h3>
                                        <p className="mt-1 text-sm text-gray-500">
                                            {t('This file type cannot be previewed. Please download to view.')}
                                        </p>
                                        <div className="mt-6">
                                            <button
                                                onClick={() => handleDownloadDocument(previewDocument)}
                                                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                                style={{ backgroundColor: 'rgb(40 95 116 / var(--tw-bg-opacity, 1))' }}
                                            >
                                                <ArrowDownTrayIcon className="h-5 w-5" />
                                                {t('Download File')}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className="bg-gray-50 px-4 py-3 flex justify-end border-t border-gray-200">
                                <button
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    onClick={() => setShowDocumentPreview(false)}
                                >
                                    {t('Close')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
